const rowsForQuarterlyData = [
  { key: 'registered_users', title: 'Total Registered Users' },
  { key: 'activeUsers', title: 'Active Users' },
  { key: 'total_users_played_content', title: 'Unique users Played the content' },
  { key: 'total_mins', title: 'Total minutes played' },
  { key: 'total_users_rated_content', title: 'Unique Users Rated the Content' },
  { key: 'total_users_favorite_the_content', title: 'Unique users Favourite the content' },
  { key: 'total_steps', title: 'Total Steps captured(M)' },
  { key: 'total_users_syncing_steps', title: 'Unique users who are syncing steps' },
  { key: 'personal_coaching_bookings_completed', title: 'Number Of Personal Coaching Completed' },
  { key: 'personal_coaching_bookings', title: 'Unique users Taken Personal Coaching' },
  { key: 'total_users_taking_waterintake', title: 'Unique users taking water intake' },
  { key: 'total_water_intake', title: 'Total Water Intakes' },
  { key: 'total_reward_points_earned', title: 'Total Earned Rewards Points' },
  { key: 'total_users_earned_rewards', title: 'Unique users Earned Rewards' },
  { key: 'total_users_redeemed_rewards', title: 'Unique users Redeemed Rewards' },
  { key: 'total_push_sent', title: 'Number of Push Sent' },
  { key: 'total_challenges_launched', title: 'Number of Challenge Launched' },
  { key: 'total_challenges_joined', title: 'Unique users Joined the challenge' },
  { key: 'total_challenges_participated', title: 'Unique users participated in challenge' },
  { key: 'programs_joined', title: 'Programs Joined' },
  { key: 'programs_completed', title: 'Programs Completed' },
  { key: 'audio_books_redeemed', title: 'Books Read' },
  { key: 'total_meal_images_uploaded', title: 'Total Meal Images Uploaded'},
  { key: 'total_meals_added', title: 'Total Meals Added'},
  { key: 'total_ai_messages', title: 'Number of messages on AI Coach' },
  { key: 'unique_nutrition_users', title: 'Unique users interacted with Nutrition feature' }
];

export default rowsForQuarterlyData;
